import '../../app.es6';
import angular from 'angular';

class GuestVideoController {
  /* @ngInject */
  constructor (
    $scope, $sessionStorage, $rootScope, $location,
    commonApiFactory, commonFactory, Const, Page
  ) {
    this.Const = Const;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$location = $location;
    this.$sessionStorage = $sessionStorage;
    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = true;
    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = 'gray';
    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
    this.commonApiFactory = commonApiFactory;
    this.commonFactory = commonFactory;
    this.commonFactory.overlayHidden();
    this.commonFactory.deleteErrorFlg();
    this.targetId = '';

    if (localStorage.getItem(this.Const.LSAPP_ROLE) === this.Const.LSAPP_ROLE_MEMBER) {
      this.$location.path('/member');
    }
    Page.setTitle(this.Const.TITLE.guestVideo);

    this.videoList = [];
    this.$rootScope.videoList = this.videoList;
    this.existsGuestVideo = false;

    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    } else {
      this.commonFactory.overlayShow();
    }
    // 権限がstaff、遷移元がゲスト動画画面、sessionにmemberIdとvideoIdを持っている場合、動画移動処理実施
    if (this.$sessionStorage[this.Const.SSAPP_ADMIN_COURSE_LIST_LOCATION] === this.Const.ADMIN_COURSE_LIST_LOCATION.guestVideo &&
      this.$sessionStorage[this.Const.SSAPP_MEMBER_ID_MOVE_TO_MEMBER] &&
      this.$sessionStorage[this.Const.SSAPP_VIDEO_ID_MOVE_TO_MEMBER]) {
      this.getGuestVideosAfterMoveToMember();
    } else {
      this.getGuestVideos();
    }

    GuestVideoController.$inject = [
      '$scope', '$sessionStorage', '$rootScope', '$location',
      'commonApiFactory', 'commonFactory', 'Const', 'Page'
    ];
  }

  getGuestVideos () {
    let reqParams = {
      schoolId: this.$sessionStorage[this.Const.SSAPP_SCHOOL_ID],
      limit: '',
      beginDateTime: '',
      order: 'desc',
      url: ''
    };
    this.commonApiFactory.getSchoolsSchoolIdVideos(reqParams)
      .then((videos) => {
        videos.forEach((video) => {
          if (video == null) { return; }
          // ゲスト動画はschoolIdが指定されている
          if (video.schoolId !== null) {
            this.videoList.push(video);
          }
        });
        this.existsGuestVideo = this.videoList.length > 0;
        if (!this.existsGuestVideo) {
          this.videoList.push({});
        }
        this.commonFactory.overlayHidden();
        this.$scope.$apply();
      });
  }

  getGuestVideosAfterMoveToMember () {
    let reqParams = {
      memberId: this.$sessionStorage[this.Const.SSAPP_MEMBER_ID_MOVE_TO_MEMBER],
      sourceVideoId: this.$sessionStorage[this.Const.SSAPP_VIDEO_ID_MOVE_TO_MEMBER]
    };
    let reqBody = {};
    this.commonApiFactory.postMembersVideosByVideoId(reqParams, reqBody)
      .then((res) => {
        // 生徒動画を登録したのでゲスト動画を削除する
        let deleteVideoParams = {
          videoId: this.$sessionStorage[this.Const.SSAPP_VIDEO_ID_MOVE_TO_MEMBER]
        };
        return this.commonApiFactory.deleteVideosVideoId(deleteVideoParams);
      })
      .then(() => {
        // 削除後のゲスト動画一覧を取得する
        return this.getGuestVideos();
      })
      .then(() => {
        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_MOVE_VIDEO_TO_MEMBER_COMPLETE, 3000, false);
        this.$sessionStorage[this.Const.SSAPP_ADMIN_COURSE_LIST_LOCATION] = '';
        this.$sessionStorage[this.Const.SSAPP_MEMBER_ID_MOVE_TO_MEMBER] = '';
        this.$sessionStorage[this.Const.SSAPP_VIDEO_ID_MOVE_TO_MEMBER] = '';
      });
  }

  removeVideo (index) {
    this.videoList.splice(index, 1);
    this.existsGuestVideo = this.videoList.length > 0;
    if (!this.existsGuestVideo) {
      this.videoList.push({});
    }
    this.$scope.$apply();
  }
}

angular.module('myApp').controller('GuestVideoController', GuestVideoController);



// WEBPACK FOOTER //
// ./app/components/guest-video/guest-video-controller.es6